import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  FileValidationConfig,
  IMAGE_ONLY,
  validateUploadFile,
} from "../utils/fileValidation";

export const useImageUpload = (config: FileValidationConfig = IMAGE_ONLY) => {
  const [imageToUpload, setImageToUpload] = useState<File | null>(null);

  const [imagePreview, setImagePreview] = useState<string>("");

  useEffect(() => {
    if (!imageToUpload) return;

    const filePreviewUrl = URL.createObjectURL(imageToUpload);
    setImagePreview(filePreviewUrl);

    return () => {
      URL.revokeObjectURL(filePreviewUrl);
    };
  }, [imageToUpload]);

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const result = validateUploadFile(file, config);
    if (!result.valid) {
      toast.error(result.error);
      e.target.value = "";
      return;
    }

    setImageToUpload(file);
  };

  return { imageToUpload, imagePreview, handleImageUpload, setImageToUpload };
};
